import { Link, Typography, Box } from '@mui/material';
import labels from '../../dictionaries/labels.json';
import './footer.css';

function Footer() {
  const date = new Date();
  const year = date.getFullYear();
  return (
    <Box
      sx={{
        display: 'flex',
        direction: { lg: 'row', xl: 'row', md: 'row', sm: 'column' },
        alignItems: 'center',
        justifyContent: 'center',
        height: 'fit-content',
        flexWrap: 'wrap',
        bottom: '0',
        position: 'sticky',
        width: '100%',
        backgroundColor: '#f8f9fa',
        pb: 2,
        pt: 2,
      }}
    >
      <Typography id='item-keee'>
        {
          <span> {labels.footer.itemKEEE} </span>
        }
        {` ${year}`}
      </Typography>
      <Link id='item-terms' href='/policy'
        underline='hover'>
        {
          <Typography style={{ display: 'inline-flex' }} color='secondary'>
            {labels.footer.itemTerms}
          </Typography>
        }
      </Link>
      <Typography id='item-knowledge' style={{ marginLeft: '4rem' }}>
        {`${labels.footer.itemDesignedBy} `}
        <Link
          href='https://www.knowledge.gr/'
          target='_blank'
          underline='hover'
          style={{
            display: 'inline-flex',
            textTransform: 'uppercase',
            marginLeft: '.5rem',
          }}
          color='secondary'
        >
          <span> {labels.footer.knowledge} </span>
        </Link>
      </Typography>
    </Box>
  );
}

export default Footer;
